export default {
translation: {
"time.s":"s",
"duration.seconds":"seconds",
"duration.days":"days",
"duration.hours":"hours",
"duration.minutes":"minutes",

"Отмена":"Cancel",
"Ошибка":"Error",

"Требуется вход":'Login required',
"Вы вышли":'You have logged out',
"Не указан логин или пароль":'No login or password',
"Неправильный логин или пароль":'Invalid login or password',
"auth.login-title": "Login",
"Адрес электронной почты":"Email address",
"Пароль":'Password',
"Войти":"Login",
"Забыли пароль ?":"Forgot password ?",
"Восстановить":"Recover",
"Нет аккаунта ?":"No account ?",
"Зарегистрироваться":"Register",
"или войдите с": "or login with",
"Успешный вход":"Login successfull",
"Неправильный адрес":"Invalid email",
"Неправильный пароль":"Invalid password",
"Пароли не совпадают":"Passwords do not match",
"auth.recover-title":"Recover",
"Назад ко входу":"Back to login",
"auth.register-title":"Register",
"Повторите пароль":'Repeat password',
"Уже зарегистрированы ?":"Already registered ?",
"Не удалось зарегистрироваться":"Could not register",
"Ошибка верификации":"Verification error",
"Ошибка регистрации":"Registration error",
"Адрес уже зарегистрирован":"Email already registered",
"auth.verify-title":"Verify",
"Код подтверждения":"Verification code",
"Проверить":"Verify",
"Электронный адрес":"Email",
"Код подтверждения":"Verification code",
"Код отправлен":"Code sent",
"Неверный код":"Invalid code",
"Повторно отправить через":"Resend after",
"Не получили код ?":"Did not receive the code ?",
"Отправить еще раз":"Send again",
"Вернуться к восстановлению":"Back to recover",
"Ко входу":"To login",
'Ошибочные параметры':"Invalid parameters",
"Восстановление не удалось":"Recover failed",
"Ошибка восстановления":"Recover error",
"Адрес подтверждён":"Address confirmed",
"auth.reset-title":"Password reset",
"Новый пароль":"New password",
"Установить":"Set",
"Вернуться ко входу":"Back to login",
"Ошибка подтверждения":"Verification error",
"Сброс не удался":"Reset failed",
'Пароль изменён':"Password changed",
"Ошибка сброса":"Password reset error",

"Аккаунт":"Account",
"Подписки":"Subscriptions",
"Выйти":"Logout",
"Панель Администратора":"Admin Panel",
"Подтвердите выход":"Confirm logout",
"Вы действительно хотите выйти из Nestarenie.Expert ?":"Do you want to log out of Nestarenie.Expert ?",
"Панель Тестировщика":"Tester Panel",
"Главная":"Home",
"Шаг 1: В лабораторию":"Step 1: To the lab",
"Шаг 2: Вопросы":"Step 2: Questions",
"Есть неотвеченные вопросы":"There are unanswered question",
"Сначала ответьте на все вопросы":"Answer the questions first",
"Шаг 3: Анализы":"Step 3: Lab tests",
"Динамика по панелям":"Panel dynamics",
"Мои панели":"My panels",
"Личные замеры":"Personal measurements",
"альфа версия":"alpha version",
"Сначала заполните хотя бы некоторые анализы":"Fill in at least some of the lab tests",
"Сначала пройдите предыдущий шаг":"Complete previous step first",
"Шаг 4: Риски":"Step 4: Risks",
"Шаг 5: Оценка возраста":"Step 5: Age estimation",
"Шаг 6: План":"Step 6: Plan",
"Шаг 7: Что дальше":"Step 7: What's next",
"Данные":"Data",
"Чатбот":"Chatbot",
'ОсОО "Нестарение Инвестмент"':'Nestarenie Investment LLC',
"чат поддержки":"support chat",
"Обновляем":"Updating",
"Для полного пересчёта":"For full recalculation,",
"подключите подписку":"Enable subscription",
"обновлён":"updated",
"Пересчитать ваши результаты":"Recalculate your results",
"скрыть":"hide",

"button-close": "Close",
"button-reset": "Reset",
"button-save": "Save",

"list-and": ", and ",

"загрузка":"loading",
"Ошибка поиска":"Search error",
"найдено":"found",
"ничего не найдено":"Nothing found",
"показано":"shown",
"Введите параметр":"Input a parameter",
"Ввод":"Input",
"button-close": "Close",

"list-and": ", and ",

"лет жизни_one": "{{count}} year",
"лет жизни_other": "{{count}} years",

"payment-gateway-moneta": "Payment from Russia",
"payment-gateway-moneta-desc": "MIR, SBP",

"payment-gateway-finik": "Worldwide",
"payment-gateway-finik-desc": "VISA, SBP, QR Kyrgyzstan",

"audioplayer-listen":"listen",
"flow-warning-answer":"Answer",

"privacy-policy": 'Privacy policy',
"privacy-policy-url": 'https://nestarenie.expert/2026/09/05/1_en/',
"user-agreement": 'User agreement',
"user-agreement-url": 'https://nestarenie.expert/2026/09/05/2_en/',

"вопросы":"the questions",
"и заполните":"and fill in",
"данные анализов":"lab tests data",

"Обновляем": "Calculating",
"Для полного пересчёта": "For full calculation",
"подключите подписку": "purchase subscription",
"обновлён":"updated",
"Язык переключён":"Language switched",
"Пересчитать ваши результаты":"Recalculate your results",
"скрыть":"hide",
"ещё":"more",

"Пересчитываем результаты":"Recalculating results",
"Готово":"Done",

"Приобретите":"Purchase",
"Премиум подписку":"Premium subscription",
", чтобы получить доступ ко всему содержимому":" to get access to all the content",
"Ваша подписка истекла и эти результаты расчёта больше не обновляются":"Your subscription had expire, and these results are no longer being updated",
"снова, чтобы возобновить выполнение расчёта":"again to continue getting updated calculation results",

"Риски":"Risks",
"чтобы узнать ваши риски":"to know your risks",
"У Вас нет выявленных рисков.":"You have no risks identified.",
"Обязательно прочитайте об этом риске!":"Be sure to read about this risk!",

'Доступно только для спонсоров':'Available only for sponsors',
"Оценка возраста":"Age estimation",
"чтобы узнать возраст систем вашего организма":"to find out the age of your body systems",
"Продолжительность жизни, годы":"Life expectancy, years",
"ОПЖ":"LE",
"Здоровая ОПЖ":"Healthy LE",
"Без выполнении плана":"Without fulfilling the plan",
"При выполнении плана":"While fulfilling the plan",
"План действий":"Action plan",
"Калькулятор возраста":"Age calculator",

"План":"Plan",
"Отметить все шаги как невыполненные?":"Mark all steps as incomplete?",
"Восстановить все шаги":"Restore all steps",
"Скачать план в PDF": "Download plan as PDF",
"Открыть экспорт" : "Open in browser",
"Скачать полный экспорт в PDF": "Download full export PDF",

"Вы прошли":"You've completed",
"из":"of",
"вопросов":"questions",
"Пройти оставшиеся вопросы":"Pass the remaining questions",
"чтобы получить план":"to receive your plan",

"Чтобы Nestarenie.Expert смог составить для вас план":"To help Nestarenie.Expert create a plan for you",
"пройдите все вопросы":"please complete all the questions",
"Заполните":"Fill in",
"данные анализов":"your lab tests data",
"Не обязательно заполнять всё, если вы не сдавали кровь в лаборатории. Можете заполнить только те поля, которые знаете. Например,":"You don't need to fill out everything if you haven't donated blood in a lab. You can fill in only the fields you know, such as",
"вес":"weight",
"рост":"height",
"окружность талии":"waist circumference",
"это сделает результаты более точными":"this will make the results more accurate",
"может добавить":"can add",
"Обязательно прочитайте об этом шаге":"Be sure to read about this step",
"Ссылки на клинические рекомендации":"Links to clinical guidelines",
"Отметить шаг выполненным":"Mark step as completed",

"Сегодня":"Today is",
"Совет дня":"Tip of the Day",

"Скачать приложение":"Download App",
"Шаг 1: Посетить лабораторию":"Step 1: Visit the lab",
"Шаг 2: Ответить на вопросы":"Step 2: Answer the questions",
"Шаг 3: Лабораторные анализы":"Step 3: Lab tests",
"Шаг 4: Узнайте ваши риски":"Step 4: Your risks",
"Шаг 5: Оценка возраста":"Step 5: Age estimation",
"Шаг 6: Ознакомьтесь с Планом продления жизни":"Step 6: Life extension plan",
"Шаг 7: Что дальше":"Step 7: What's next",
"":"",

"К следующему шагу":"To the next step",

'Сделайте обследование "Тераностика старения" в медицинском центре':'Get a "Theranostics of Aging" examination at a medical center',
"ДНКОМ или AquaLab":"DNKOM or AquaLab",
"Подготовка пациента к анализу крови Тераностика старения":"Preparing the patient for the Theranostics of Aging blood test",
"blood-test-preparation-url":"https://non-aging.expert/podgotovka.html",

"Консультация врача":"Doctor consultation",

"Автоудаление через": "Autodelete in",
"Информация из https://nestarenie.ru и":"Information from https://nestarenie.ru and",
"Тест скопирован":"Text copied",
"Соответствие":"Similarity",
"Сообщить о плохом ответе":"Report a bad response",
"Отменить сообщение о плохом ответе":"Undo report",
"Оставить комментарий":"Leave a comment",
"Копировать ответ":"Copy an answer",
"Копировать все ответы":"Copy all answers",
"Закрепить":"Pin",
"Открепить":"Unpin",
"Удалить":"Delete",
"Удалить сейчас":"Delete now",
"Нет ответа":"No answer",
"Лимит вопросов исчерпан":"Question limit reached",
"Неожиданный ответ сервера":"Unexpected server response",
"chatbot-limit-part-1":"There are",
"chatbot-limit-part-2":"questions left",
"chatbot-input-prompt":"Your question (? for help)",
"chatbot-mode-consultant":"Consultant mode",
"chatbot-mode-expert":"Expert mode",
"chatbot-mode-kb-1":"Knowledge base, 1 answer",
"chatbot-mode-kb-2":"Knowledge base, 2 answers",
"chatbot-mode-kb-3":"Knowledge base, 3 answers",
"chatbot-mode-na":"Only available for subscribers",

"Дата и время":"Date & Time",
"Часовой пояс":"Timezone",
"Подтвердите действие":"Confirm action",
"Сбросить несохранённые данные ?":"Reset unsaved data ?",
"Сохранение":"Saving",
"Есть несохраненные изменения в сессии":"There are unsaved changes in the session",
"Вы можете либо продолжить её редактирование, либо перейти к другой сессии, потеряв несохранённые данные": "You can either continue editing this session or switch to another session and lose your unsaved changes",
"Продолжить редактирование":"Continue editing",
"Потерять изменения":"Discard changes",
}
};
